goog.provide('el8.data.practiceUsers');

goog.require('el8.model.base');
goog.require('el8.service.urls');
goog.require('el8.data.model.user');
goog.require('el8.data.referencedUsers');
goog.require('el8.data.staffGroups');
// goog.require('el8.ptdata.patients'); -- circ dep
goog.require('el8.util.workspace');

/**
 * This only holds users IN THE CURRENT PRACTICE
 * (otherwise look at el8.data.referencedUsers)
 */
el8.data.practiceUsers = (function() {

    var that = new el8_EntitySet({
        model: function(spec) { return new el8.data.model.user(spec); },
        items: [],
        urlFn: function(id) { return '/users/'+id+'/'; },
        urlLoad: '/users/json/'
    });

    var super_create = that.create;
    that.create = function(var_args) {
        // Also call create on referencedUsers
        el8.data.referencedUsers.create.apply(el8.data.referencedUsers, arguments);
        return super_create.apply(that, arguments);
    };

    that.getPhysicianUsers = function(includeDisabledAndElationStaff) {
        var all = (includeDisabledAndElationStaff) ? super_all.call(that) : that.all();
        var pUsers = [];
        for (var i=0; i<all.length; i++) {
            if (all[i].isPhysician()) {
                var map = all[i].asSoyMap();
                map.name = all[i].getFullName();
                map.isElationStaff = all[i].isElationStaff();
                pUsers.push(map);
            }
        }
        return pUsers.sort(function(a, b) {
            return (a.name).localeCompare(b.name);
        });
    };

    /**
     * This function appends a single user to an existing list of things.
     * Those things are generally an array of practiceUsers, but could be something else.
     *
     * @param {*} initialList generally the return of a practiceUsers.js
     *      fetch that returns an array, but other entity arrays may work
     * @param {*} includeUser a user id (passed to getById)
     *      or the user getById/getByStaffId would return. If a number is
     *      provided, elation staff and/or inactive staff are allowed.
     */
    that.getWithIncluding = function(initialList, includeUser){
        var ret = initialList;
        var include = typeof includeUser === "number" ? that.getById(includeUser,true) : includeUser;
        // Guard against non-array result or bogus includes and return whatever we could (or couldn't) get
        if (!Array.isArray(ret) || !include){
            console.warn("Unexpected value received by el8.data.practiceUsers.getWithIncluding", arguments);
            return include === undefined ? [] : [include];
        }
        // Support most if not all sane forms of the passed in user shape
        var includeId = typeof include.getId === "function" ? include.getId() : include.id || include._id;
        if (!ret.some(function (phys){
            return phys.id === includeId
        })){
            ret.push(include);
        }
        return ret;
    }

    that.getStaffUsers = function(includeDisabledAndElationStaff) {
        var all = (includeDisabledAndElationStaff) ? super_all.call(that) : that.all();
        var sUsers = [];
        for (var i=0; i<all.length; i++) {
            if (all[i].isOfficeStaff()) {
                var map = all[i].asSoyMap();
                map.name = all[i].getFullName();
                map.isElationStaff = all[i].isElationStaff();
                sUsers.push(map);
            }
        }
        return sUsers.sort(function(a, b) {
            return (a.name).localeCompare(b.name);
        });
    };

    that.isSinglePhysicianPractice = function() {
        return (that.getPhysicianUsers().length === 1);
    };

    that.isMember = function(userId) {
        if (!userId) { return false; }
        return _.contains(
            _.map(that.all(), function(u) { return u.getId(); }),
            userId);
    };

    that.isMemberByStaffId = function(staffId) {
        if (!staffId) { return false; }
        return _.contains(
            _.map(that.all(), function(u) { return u.getStaffId(); }),
            staffId);
    };

    that.getByStaffId = function(staffId, includeDisabledAndElationStaff) {
        if (!staffId) { return null; }
        var all = (includeDisabledAndElationStaff) ? super_all.call(that) : that.all();
        return _.find(all, function(u) {
            return (u.getStaffId() === staffId);
        });
    };

    // we don't really want that.all() to return disabled users or Elation Staff
    var super_all = that.all;
    that.all = function() {
        var all = super_all.call(that);
        return all.filter(function(user) {
            return user.isActive() && !user.isElationStaff();
        });
    };

    // arg can either be a single id, or an array of id's
    that.allExcept = function(arg) {

        var all = that.all();
        if (!arg) { return all; }

        var exceptIdMap = {};
        if (arg.length === undefined) {
            exceptIdMap[arg] = true;
        } else {
            for (var i=0; i<arg.length; i++) {
                exceptIdMap[arg[i]] = true;
            }
        }
        var rUsers = [];
        for (var i=0; i<all.length; i++) {
            if (!exceptIdMap[all[i].getId()]) {
                rUsers.push(all[i]);
            }
        }
        return rUsers;
    };

    that.nameExists = function(name, physiciansOnly) {
        if (physiciansOnly) {
            var allNames = _.pluck(this.getPhysicianUsers(), 'fullName');
            return _.contains(allNames, name);
        } else {
            var allNames = _.pluck(this.allAsSoyMaps(), 'fullName');
            return _.contains(allNames, name);
        }
    };

    that.getAssigneeObjects = function(patientId) {
        // List of possible assignees (users and staff groups in a convenient order)
        // to share with various dlgs

        var assigneeObjects = [];

        patientId = patientId ? patientId : el8.ptdata.currPatient.getId();
        var patient = el8.ptdata.patients.getById(patientId);

        var currUserid = el8.data.currUser.getId();

        // Self if I'm a physician
        if (el8.data.currUser.isPhysician()) {
            assigneeObjects.push(el8.data.currUser);
        }

        // PCP, if it's not me
        var primaryId = patient.getPrimaryPhysicianUserId();
        if (currUserid !== primaryId) {
            assigneeObjects.push(el8.data.practiceUsers.getById(primaryId));
        }

        // SGs I'm a part of
        var myGroups = el8.data.staffGroups.getGroupsForUser(currUserid);
        var myGroupsIds = _.map(el8.myGroups, function(sg) { return sg.getId(); });
        assigneeObjects.concat(myGroups);

        // Other SGs and users
        assigneeObjects = assigneeObjects.concat(el8.data.staffGroups.allExcept(myGroupsIds));
        assigneeObjects = assigneeObjects.concat(el8.data.practiceUsers.allExcept([currUserid, primaryId]));

        return assigneeObjects;
    };

    function buildGetAssignees(assigneesSourceFunction){
        return function(patientId){
            var reminderAssignees = [];
            var _assigneeForSoy = function(item) {
                if (item.getModelClass() === 'User') { // User is not an el8Id
                    return {id: item.getId(), name: item.getFullName()};
                } else if (el8.model.idToModelClass(item.getId()) === 'StaffGroup') {
                    return {id: item.getId(), name: item.getName() + ' (Group)'};
                }
            };

            _.each(assigneesSourceFunction(patientId), function(assignee) {
                reminderAssignees.push(_assigneeForSoy(assignee));
            });

            return reminderAssignees
        }
    }

    that.getAssignees = buildGetAssignees(that.getAssigneeObjects)

    that.extractAssigneeObj = function(userOrGroupId) {
        // Converts userOrGroupId to reminder group or user obj for extending maps to post
        var ret = {
            reminderGroupId: null,
            reminderUserId: null
        };

        if (el8.model.idToModelClass(userOrGroupId) === 'StaffGroup' &&
            el8.data.staffGroups.getById(userOrGroupId)) {
            ret['reminderGroupId'] = userOrGroupId;
        }
        else {
            ret['reminderUserId'] = userOrGroupId;
        }
        return ret;
    };


    // Prepare for workspaces awareness
    el8.util.workspace.bindToDataModelUpdates(that);

    // Workspace aware version of the above functions (safe for use with or without workspace)
    that.allInWorkspace = el8.util.workspace.filteringWrapper(that.all);
    that.allInWorkspaceExcept = el8.util.workspace.filteringWrapper(that.allExcept);
    that.getPhysicianUsersInWorkspace = el8.util.workspace.filteringWrapper(that.getPhysicianUsers);
    // Although getAssigneeObjects returns a mix of users and groups, groups are filterable by the same wrapper
    that.getAssigneesInWorkspace = buildGetAssignees(el8.util.workspace.filteringWrapper(that.getAssigneeObjects));

    /**
     * Workspaces can be made with only one physician which should make some things
     * act like a single user practice, but that can be conditional on data at the
     * point a consumer calls this function.
     *
     * That data can be passed in via includePhysician, generally a physician already
     * selected on an item. That way this function can see if that physician is the
     * only physician in the workspace and return true, but if that physician is not
     * in the workspace and the logged-in user is a physician,
     * then it should act as if it is in a two physician practice.
     * @param includePhysician physician user id or physician user
     * @returns boolean
     */
    that.isVirtualSinglePhysicianPractice = function(includePhysician) {
        // guard against wasted work if we are not in a relevant workspace, assuming
        //   this covers true single physician practices too as workspaces are for enterprises
        if (!el8.util.workspace.isInEffect()){
            return that.isSinglePhysicianPractice();
        }
        return that.getWithIncluding(that.getPhysicianUsersInWorkspace(), includePhysician).length === 1
    };

    return that;

})();
